import { ReactElement } from "react";

export default function Content(props : {children: ReactElement<any, any>, active: string, name: string}) {
    return (
        <div className={(props.active === props.name ? "block" : "hidden") + " md:p-8 p-4 overflow-y-scroll overflow-x-hidden h-full"}>
            {props.children}
        </div>
    );
}